// the key for the local storage.
const sessionStorageKey = '__ea_session__';

// Save to session storage
export function setSavedState(state: any) {
    sessionStorage.setItem(sessionStorageKey, JSON.stringify(state));
}

// Load from session storage
export function getSavedState(): any {
    return JSON.parse(sessionStorage.getItem(sessionStorageKey));
}
